import React, { FC } from 'react'

import Image, { ImageProps } from 'next/image'

const NextImage: FC<ImageProps> = (props) => {
  const { src } = props
  const getImageURL: any = () => {
    return src
  }

  //@ts-ignore
  return <Image unoptimized loader={getImageURL} src={src} {...props} />
}

export default NextImage
